<template>
    <fieldset>
        <div class="col-md-4 radio">
            <label>
                <input type="radio" name="shippingSource" @change="sourceChanged" checked>
                <span>Lieferadresse</span>
            </label>
        </div>
        <div class="col-md-5">
            <select2 v-if="addressbook.length && ! addNewAddress && enabled" :options="addressbookData" v-model="selectedAddress"></select2>
        </div>
        <div class="col-md-3 checkbox" v-if="addressbook.length == 1">
            <label>
                <input type="checkbox" name="addNewAddress" v-model="addNewAddress">
                <span>Alternative Lieferadresse</span>
            </label>
        </div>
        <div class="col-md-12" v-if="addNewAddress && enabled">
            <new-address v-model="address" :countries="countries" :user="user" ref="newAddress"></new-address>                
        </div>
    </fieldset>
</template>

<script>

import {clone} from "lodash";
import Select2 from "../../../../select2/Select2.vue";
import NewAddress from './NewAddress.vue';

export default {

    components: {
        Select2,
        NewAddress
    },

    props: {
        user: {
            required: true,
            default: null
        },
        countries: {
            required: true,
            default: []
        },
        addressbook: {
            required: true,
            default: []
        }
    },

    data() {
        return {
            enabled: true,
            address: clone(this.user),
            addNewAddress: false,
            loadingAddressBook: false,
            selectedAddress: 0,
            newAddress: {
                company: '',
                name: '',
                street: '',
                city: '',
                zip: '',
                country: '156',
                countryName: '',
            },
        }
    },

    computed: {
        
        addressbookData() {
            return this.addressbook.map((address, i) => {
                return {
                    'id': i,
                    'text': `${i + 1}. ${address.company}, ${address.street}, ${address.zip} ${address.city}, ${address.countryName}`
                }
            });
        }
    },

    created() {

        App.event.listen('shipping.source.changed', ({who}) => {
            this.enabled = who == 'all';
            this.emitChange();
        });
        
    },

    methods: {
        
        sourceChanged() {
            App.event.fire('shipping.source.changed', { who: 'all' });
        },

        validate() {
            if (this.enabled) {
                return (
                    this.validField('company') &&
                    this.validField('street') &&
                    this.validField('city') &&
                    this.validField('zip')
                );
            } else {
                return true;
            }
        },

        validField(name) {
            return this.address[name].length > 0;
        },

        emitChange() {
            if (this.enabled) {
                this.$emit('change', {
                    address: clone(this.address),
                    isNew: this.addNewAddress
                });
            }
        }

    },

    watch: {

        addNewAddress() {
            this.address = this.addNewAddress ? clone(this.newAddress) : clone(this.addressbook).shift();
        },

        selectedAddress() {
            this.address = this.addressbook[this.selectedAddress];
        },

        address: {
            deep: true,
            handler: function() { this.emitChange(); }
        }

    }

}
</script>
